/**
 * This files is an example of defining all of our routes and "lazy loading" them.
 * Using the "lazy loading" chunking strategy, routes won't be a part of the initial
 * bundle and the code for each route won't be AJAXed in until the route is clicked on.
 * @since 2/1/19
 * @file
 */

import React from 'react';
import { withLazyLoad } from '@passportinc/hydraulics';

import {
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';

const Apply = withLazyLoad(() => import('./pages/apply'));
const ProvideDocuments = withLazyLoad(() => import('./pages/provide-documents'));
const Landing = withLazyLoad(() => import('./pages/landing'));
const Dashboard = withLazyLoad(() => import('./pages/dashboard'));
const PermitDetails = withLazyLoad(() => import('./pages/permit-details'));
const ManagePermits = withLazyLoad(() => import('./pages/manage-permits'));
const FrequentlyAskedQuestions = withLazyLoad(() => import('./pages/faq'));
const CheckoutPage = withLazyLoad(() => import('./pages/checkout/CheckoutPage'));

const Routes = props => (
  <Switch>
    {/* Redirects */}
    <Redirect exact from="/" to="/permits/login" />
    <Redirect exact from="/permits/" to="/permits/login" />

    {/* Routes related to user login/create acount/forgot password */}
    <Route exact path="/change-password" render={() => <Landing {...props} />} />
    <Route exact path="/permits/login" render={() => <Landing {...props} />} />
    <Route exact path="/permits/create-account" render={() => <Landing {...props} />} />
    <Route exact path="/permits/forgot-password" render={() => <Landing {...props} />} />
    <Route exact path="/permits/change-password" render={() => <Landing {...props} />} />

    {/* User Account/Dashboard */}
    <Route exact path="/permits/dashboard" render={() => <Dashboard {...props} />} />

    {/* Manage Permits */}
    <Route exact path="/permits/manage/:permitId" render={() => <ManagePermits {...props} />} />
    <Route exact path="/permits/manage/:permitId/:path" render={() => <ManagePermits {...props} />} />

    {/* Permit Application Flow */}
    <Route exact path="/permits/apply" render={() => <Apply {...props} />} />
    <Route exact path="/permits/apply/:appId" render={() => <Apply {...props} />} />
    <Route exact path="/permits/details/:id" render={() => <PermitDetails {...props} />} />
    <Route exact path="/permits/permit-details/:id" render={() => <PermitDetails {...props} />} />
    <Route exact path="/permits/checkout" render={() => <CheckoutPage {...props} />} />
    <Route exact path="/permits/provide-documents/:id" render={() => <ProvideDocuments {...props} />} />

    {/* Miscellaneous/Fallback */}
    <Route exact path="/permits/faq" render={() => <FrequentlyAskedQuestions {...props} />} />
    <Redirect to="/permits/dashboard" />
  </Switch>
);

export default Routes;
